import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    defaultError: 'An error occurred while saving your changes',
    success: 'Your changes have been saved',
  },
  fr: {
    defaultError:
      'Une erreur est survenue lors de la sauvegarde de vos modifications',
    success: 'Vos modifications ont été sauvegardées',
  },
} as const);

export default locales;
